import React from 'react';
import { primaryTextColor } from '../../themes/index';

function Tool({
  fill = primaryTextColor,
  width = 18,
  height = 18,
  style,
  className,
}) {
  return (
    <svg
      width={width}
      height={height}
      style={style}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7499 13.8667L7.44993 9.53333C7.19438 9.62222 6.93882 9.69444 6.68327 9.75C6.42771 9.80556 6.1666 9.83333 5.89994 9.83333C4.82123 9.83333 3.90433 9.45741 3.14923 8.70555C2.39415 7.95371 2.0166 7.04074 2.0166 5.96667C2.0166 5.62222 2.06192 5.28673 2.15257 4.9602C2.24321 4.63366 2.37011 4.3247 2.53327 4.03333L4.94993 6.45L6.48327 5.01667L3.99994 2.53333C4.28788 2.36491 4.5932 2.23392 4.91588 2.14035C5.23858 2.04678 5.5666 2 5.89994 2C7.00179 2 7.93836 2.38565 8.70965 3.15695C9.48095 3.92824 9.8666 4.86481 9.8666 5.96667C9.8666 6.23333 9.83882 6.49444 9.78327 6.75C9.72771 7.00556 9.65549 7.26111 9.5666 7.51667L13.8833 11.8167C14.0055 11.9384 14.0666 12.0855 14.0666 12.258C14.0666 12.4304 14.0055 12.5778 13.8833 12.7L12.6166 13.8667C12.4978 13.9889 12.3542 14.05 12.1858 14.05C12.0174 14.05 11.8722 13.9889 11.7499 13.8667ZM12.2166 12.9167L12.8833 12.25L8.33327 7.7C8.51105 7.46667 8.64438 7.19167 8.73327 6.875C8.82216 6.55833 8.8666 6.25556 8.8666 5.96667C8.8666 5.13333 8.55827 4.42778 7.9416 3.85C7.32493 3.27222 6.62216 2.97778 5.83327 2.96667L7.5166 4.68333C7.6166 4.78333 7.6666 4.90556 7.6666 5.05C7.6666 5.19444 7.6166 5.31667 7.5166 5.41667L5.3166 7.48333C5.2166 7.58333 5.09438 7.63333 4.94993 7.63333C4.80549 7.63333 4.68327 7.58333 4.58327 7.48333L2.9666 5.88333C2.99993 6.73889 3.30365 7.44444 3.87774 8C4.45182 8.55556 5.12589 8.83333 5.89994 8.83333C6.17771 8.83333 6.47216 8.78889 6.78327 8.7C7.09438 8.61111 7.3666 8.47778 7.59994 8.3L12.2166 12.9167Z"
        fill={fill}
      />
    </svg>
  );
}

export default Tool;
